import React from 'react';

export const MiddleHeaderComponent = () => (
	<React.Fragment>

	</React.Fragment>
);
